import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
const TARGET_FLOW = {
    id: 'target_material_flow',
    type: 'target',
    name: 'Сырьё',
    position: Position.Bottom,
    style: { bottom: 25, left: 75, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_FLOWS = {
    id: 'target_material_flows',
    type: 'target',
    name: 'Сырьё',
    position: Position.Bottom,
    style: { bottom: 25, left: 75, background: M_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const TARGET_RECYCLE_FLOW = {
    id: 'target_material_recycle_flow',
    type: 'target',
    name: 'Рециркулирующий поток',
    position: Position.Bottom,
    style: { bottom: 25, left: 69, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_GAS_FLOW = {
    id: 'source_material_gas_flow',
    type: 'source',
    name: 'Дымовые газы',
    position: Position.Top,
    style: { top: 8, left: 28, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_PRODUCT_FLOW = {
    id: 'source_material_product_flow',
    type: 'source',
    name: 'Продукты из реактора',
    position: Position.Right,
    style: { top: 26, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_TOP_PRODUCT_FLOW = {
    id: 'source_material_top_product',
    type: 'source',
    name: 'Сухой газ',
    position: Position.Right,
    style: { top: 26, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_1_FLOW = {
    id: 'source_material_frac_1',
    type: 'source',
    name: 'ППФ',
    position: Position.Right,
    style: { top: 49, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_2_FLOW = {
    id: 'source_material_frac_2',
    type: 'source',
    name: 'ББФ',
    position: Position.Right,
    style: { top: 71, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_3_FLOW = {
    id: 'source_material_frac_3',
    type: 'source',
    name: 'Бензин',
    position: Position.Right,
    style: { top: 93, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_4_FLOW = {
    id: 'source_material_frac_4',
    type: 'source',
    name: 'Лёгкий газойль',
    position: Position.Right,
    style: { top: 115, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_FRAC_5_FLOW = {
    id: 'source_material_frac_5',
    type: 'source',
    name: 'Технологический конденсат',
    position: Position.Right,
    style: { top: 136, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const SOURCE_BOTTOM_PRODUCT_FLOW = {
    id: 'source_material_bottom_product',
    type: 'source',
    name: 'Тяжелый газойль',
    position: Position.Right,
    style: { top: 160, right: 8, background: M_FLOW_HEX },
    connectionCount: 1
};
const TARGET_LOGICAL = {
    id: 'target_logical_flow',
    type: 'target',
    name: 'Входные параметры',
    position: Position.Left,
    style: { top: 178, left: 9, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
const SOURCE_LOGICAL = {
    id: 'source_logical_flow',
    type: 'source',
    name: 'Выходные параметры',
    position: Position.Right,
    style: { top: 178, right: 8, background: L_FLOW_HEX },
    connectionCount: Number.MAX_SAFE_INTEGER
};
export const CAT_CRACKING_CONFIG = {
    type: ERFElement.CatCracking,
    icon: 'CatCracking_2d',
    templates: [
        {
            code: 'universal-template-1',
            ports: [TARGET_FLOW, TARGET_RECYCLE_FLOW, SOURCE_GAS_FLOW, SOURCE_PRODUCT_FLOW]
        },
        {
            code: 'universal-template-2A',
            ports: [
                TARGET_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_FRAC_3_FLOW,
                SOURCE_FRAC_4_FLOW,
                SOURCE_FRAC_5_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template-2B',
            ports: [
                TARGET_FLOW,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_FRAC_3_FLOW,
                SOURCE_FRAC_4_FLOW,
                SOURCE_FRAC_5_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template-3',
            ports: [TARGET_FLOWS, TARGET_RECYCLE_FLOW, SOURCE_GAS_FLOW, SOURCE_PRODUCT_FLOW]
        },
        {
            code: 'universal-template-4A',
            ports: [
                TARGET_FLOWS,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_FRAC_3_FLOW,
                SOURCE_FRAC_4_FLOW,
                SOURCE_FRAC_5_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        },
        {
            code: 'universal-template-4B',
            ports: [
                TARGET_FLOWS,
                SOURCE_GAS_FLOW,
                SOURCE_TOP_PRODUCT_FLOW,
                SOURCE_FRAC_1_FLOW,
                SOURCE_FRAC_2_FLOW,
                SOURCE_FRAC_3_FLOW,
                SOURCE_FRAC_4_FLOW,
                SOURCE_FRAC_5_FLOW,
                SOURCE_BOTTOM_PRODUCT_FLOW,
                /* PORTS FOR LOGICAL ELEMENTS */
                TARGET_LOGICAL,
                SOURCE_LOGICAL
            ]
        }
    ]
};
//# sourceMappingURL=RFCatCrackingNode.config.js.map